import React from 'react'

import classnames from 'classnames'

import { ProspectStatus } from 'core/application/ichraDecisionTool/dashboard/getProspects'

import Tooltip from 'common/components/dataDisplay/Tooltip'
import Icon from 'common/components/general/Icon'

export const internalUserStatusIconMap = new Map<ProspectStatus, string>([
  [ProspectStatus.New, 'far fa-clock'],
  [ProspectStatus.InProgress, 'far fa-sync-alt'],
  [ProspectStatus.Completed, 'far fa-check-circle'],
  [ProspectStatus.Deactivated, 'far fa-times-circle'],
  [ProspectStatus.ProposalSent, 'far fa-file-check'],
])

export const internalUserStatusTitleMap = new Map<ProspectStatus, string>([
  [ProspectStatus.New, 'New'],
  [ProspectStatus.InProgress, 'In progress'],
  [ProspectStatus.Completed, 'Completed'],
  [ProspectStatus.Deactivated, 'Deactivated'],
  [ProspectStatus.ProposalSent, 'Proposal sent'],
])

interface InternalUserStatusIconProps {
  status: ProspectStatus
}

const InternalUserStatusIcon: React.FC<InternalUserStatusIconProps> = ({ status }) => {
  const expenseReviewIconClassname = classnames(
    { 'color-blue-6': status === ProspectStatus.New },
    { 'color-yellow-6': status === ProspectStatus.InProgress },
    { 'color-green-6': status === ProspectStatus.Completed },
    { 'color-red-6': status === ProspectStatus.Deactivated },
    { 'color-gray-7': status === ProspectStatus.ProposalSent },
  )
  return (
    <Tooltip title={internalUserStatusTitleMap.get(status)}>
      <Icon
        type={`far fa-${internalUserStatusIconMap.get(status)}`}
        fontAwesome
        className={expenseReviewIconClassname}
      />
      {``}
    </Tooltip>
  )
}

export default InternalUserStatusIcon
